module.exports = __webpack_public_path__ + "static/img/logo_01.3cc3d08f.png";